// Runs after index.js
import React from 'react';
import { hydrate } from 'react-dom';
import { createBrowserHistory } from 'history';
import { loadableReady } from '@loadable/component';
import * as Sentry from '@sentry/react';

import './init-lazysizes';
import './init-web-vitals';

// retrieve data from server to hydrate the client
const props = window.__SERVER_DATA__ || {};

const genericDynamicImportErrorHandler = (err) => {
    if (process.env.NODE_ENV !== 'production') {
        throw err;
    }
    return null;
};

import('./app')
    .then((appModule) => {
        loadableReady(() => {
            const App = appModule.default;

            hydrate(
                <Sentry.ErrorBoundary fallback={'An error has occured'}>
                    <App
                        {...props}
                        history={createBrowserHistory()}
                        originalContext={props}
                    />
                </Sentry.ErrorBoundary>,
                document.getElementById('root'),
            );
        });
    })
    .catch(genericDynamicImportErrorHandler);

// Split out to keep initial bundle small
import('@eb/site-analytics')
    .then(({ initDimensionsFromState, trackInitialPageView }) => {
        // set up initial GA tracking
        initDimensionsFromState(props);

        // Don't make this call on Search because Search handles the initial page view tracking already
        if (
            window.location &&
            window.location.pathname &&
            !(window.location.pathname.indexOf('/d/') === 0)
        ) {
            trackInitialPageView(props.gaSettings);
        }
    })
    .catch(genericDynamicImportErrorHandler);
